import axios, {AxiosResponse} from 'axios';
import { Console } from 'console';
import { Message, toaster } from 'rsuite';
import { IPValueVM } from '../Models/ViewModels';
const api_url = process.env.REACT_APP_STEM_ADLOGIN+'/api'
const applicationId = process.env.REACT_APP_STEM_ADAPPLICATIONID

const fusionAuth=process.env.REACT_APP_STEM_API_BASE_URL

const authorization=process.env.REACT_APP_STEM_ADAUTHORIZATION || ''

const headers = { 
    'Content-Type': 'application/json',
      'Authorization':authorization
 };
 const FusionAuthHeader = { 
  withCredentials: true
};

export const GetLoginUser = (login:string) => 
  axios.post(api_url+'/login', {loginId:login},{headers:headers})

  export const FusionAuthApiCall = () => 
  axios.get(fusionAuth+'/api/user', FusionAuthHeader)


  export const Logout=()=>
  {
   return axios.get(fusionAuth+"/api/logout",FusionAuthHeader)
  }


